import type { ForwardedRef, ReactNode } from "react";
import { forwardRef } from "react";
import { clsx } from "clsx";

type RoundedButtonProps = {
  onClick?: () => void;
  children: ReactNode;
  active?: boolean;
  disabled?: boolean;
  className?: string;
  variant?: "primary" | "secondary";
}

export const RoundedButton = forwardRef(
  (
    { onClick, children, active, disabled, className, variant = "secondary" }: RoundedButtonProps,
    forwardedRef: ForwardedRef<HTMLButtonElement>,
  ) => (
    <button
      disabled={disabled}
      ref={forwardedRef}
      onClick={onClick}
      className={clsx(
        "flex h-10 w-10 items-center justify-center rounded-full",
        className,
        active ? "bg-primary-100" : "bg-gray-800/10",
        variant === "primary" ? "bg-primary-100 text-white" : "bg-gray-800/10",
        disabled
          ? "opacity-60"
          : active
            ? "hover:bg-primary-500 hover:text-white"
            : "hover:bg-primary-100 hover:text-white",
      )}>
      {children}
    </button>
  ),
);

RoundedButton.displayName = "RoundedButton";
